import React from 'react';
import { isKeyPressEnterEvent } from 'src/utils/common.util';
import { t } from 'src/i18n';
import CustomButton from 'src/components/CustomButton/CustomButton.component';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import ErrorMessageWithIcon from 'src/components/ErrorMessageWithIcon/ErrorMessageWithIcon.component';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import {
  DialogEmail,
  useStyles,
  FormLabel,
  DialogTitleWrapper,
  TextInputWrapper
} from './EmailPopup.style';

interface EmailPopupProps {
  values: any;
  touched: any;
  errors: any;
  dirty: boolean;
  isSubmitting: boolean;
  handleChange: any;
  handleBlur: any;
  handleSubmit: any;
  showPopup: boolean;
  hideDialog(): void;
  isLoading: boolean;
  setIsLoading(isLoading: boolean): void;
  isErrorWhenSendEmail: boolean;
}

const EmailPopup: React.FC<EmailPopupProps> = (props) => {
  const classes = useStyles();
  const [
    errorMessageSubjectField,
    setErrorMessageSubjectField
  ] = React.useState<string>('');
  const [
    errorMessageMessageField,
    setErrorMessageMessageField
  ] = React.useState<string>('');

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    showPopup,
    hideDialog,
    isLoading,
    isErrorWhenSendEmail
  } = props;

  const handleClosePopup = () => {
    hideDialog();
  };

  React.useEffect(() => {
    if (!!errors.subject && !!touched.subject) {
      setErrorMessageSubjectField(errors.subject);
    } else {
      setErrorMessageSubjectField('');
    }

    if (!!errors.content && !!touched.content) {
      setErrorMessageMessageField(errors.content);
    } else {
      setErrorMessageMessageField('');
    }
  }, [errors, touched]);

  return (
    <DialogEmail
      open={showPopup}
      onClose={handleClosePopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <LoadingContainer isLoading={isLoading}>
        <>
          <DialogTitleWrapper
            id="simple-dialog-title"
            className={classes.title}
          >
            {t('patientDocument.dialog.title')}
          </DialogTitleWrapper>
          <DialogContent>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className={classes.mb15}>
                <FormLabel>{t('patientDocument.dialog.subject')}</FormLabel>
                <TextInputWrapper
                  margin="dense"
                  name="subject"
                  label={null}
                  multiline={true}
                  fullWidth={true}
                  value={values.subject}
                  autoComplete="off"
                  variant="outlined"
                  inputProps={{
                    maxLength: 255,
                    style: { fontSize: 15, padding: 10.5 }
                  }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors.subject && !!touched.subject}
                />
                {errorMessageSubjectField && (
                  <ErrorMessageWithIcon message={errorMessageSubjectField} />
                )}
              </div>

              <div className={classes.mb15}>
                <FormLabel>{t('patientDocument.dialog.messageBody')}</FormLabel>
                <TextInputWrapper
                  multiline={true}
                  autoComplete="off"
                  variant="outlined"
                  margin="dense"
                  name="content"
                  label={null}
                  fullWidth={true}
                  rows={10}
                  inputProps={{
                    style: { fontSize: 15, padding: 10.5 }
                  }}
                  value={values.content}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors.content && !!touched.content}
                />
                {errorMessageMessageField && (
                  <ErrorMessageWithIcon message={errorMessageMessageField} />
                )}
              </div>

              <DialogActions className={classes.center}>
                <CustomButton
                  title={t('general.cancel')}
                  variant="outlined"
                  onClick={handleClosePopup}
                  isCancel={true}
                />
                <CustomButton
                  type="submit"
                  title={t('general.send')}
                  variant="contained"
                  color={'primary'}
                />
              </DialogActions>

              <div className={classes.errorSubmit}>
                {isErrorWhenSendEmail && (
                  <ErrorMessageWithIcon message={t('sendEmail.error')} />
                )}
              </div>
            </form>
          </DialogContent>
        </>
      </LoadingContainer>
    </DialogEmail>
  );
};

export default EmailPopup;
